var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C9C9C9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352,32c0-17.7,14.3-32,32-32s32,14.3,32,32v320h64c12.9,0,24.6,7.8,29.6,19.8c5,12,2.2,25.7-6.9,34.9l-96,96 c-6,6-14.1,9.4-22.6,9.4s-16.6-3.4-22.6-9.4l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9c5-12,16.6-19.8,29.6-19.8h64V32H352z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,480V160H32c-12.9,0-24.6-7.8-29.6-19.8s-2.2-25.7,6.9-34.9l96-96c6-6,14.1-9.4,22.6-9.4s16.6,3.4,22.6,9.4 l96,96c9.2,9.2,11.9,22.9,6.9,34.9c-5,12-16.6,19.8-29.6,19.8H160v320c0,17.7-14.3,32-32,32S96,497.7,96,480z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.7c8c22fa3490713431ec7f6a6bd8836b.svg";
export { ForwardRef as ReactComponent };